import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Icon } from '@mgc/react-components';
import Select from 'react-select-plus';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../../selectors';
import OfferActions from '../../actions/offer';
import CartActions from '../../actions/cart';
import UiActions from '../../actions/ui';
import HelpActions from '../../actions/help';
import Cart from '../Cart';
import Balance from '../Balance';
import Selector from './Selector';
import AddHostServer from './AddHostServer';
import MapPropTypes from '../MapPropTypes';
import PricingModal from '../Modals/PricingModal';
import CheckoutModal from '../Modals/CheckoutModal';
import SiteActions from '../../actions/sites';
import strings from '../../strings';
import utils from '../../utils';
import './OrderForm.scss';
import { Grid, Row } from 'react-bootstrap';
import UploadConfiguration from './UploadConfiguration';
import OrderActions from '../../actions/order';

const SERVER = 'server';
const PRODUCT = 'product';
import ShoppingCartModal from '../Modals/ShoppingCartModal';

class OrderForm extends Component {
    static propTypes = {
        // functions
        addProductToCart: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
        selectOffer: PropTypes.func.isRequired,
        setItems: PropTypes.func.isRequired,
        selectProduct: PropTypes.func.isRequired,
        openHelpModal: PropTypes.func.isRequired,
        saveShoppingCart: PropTypes.func.isRequired,
        downloadConfigurationProductList: PropTypes.func.isRequired,
        // data
        offer: MapPropTypes.OfferProps,
        selectedOfferIndex: PropTypes.number.isRequired,
        offers: PropTypes.arrayOf(MapPropTypes.OfferProps),
        offerIsUsable: PropTypes.bool.isRequired,
        offersRetrieved: PropTypes.bool.isRequired,
        readyForCheckout: PropTypes.bool.isRequired,
        readyForaddToCart: PropTypes.bool.isRequired,
        // site
        selectSite: PropTypes.func.isRequired,
        selectedSite: PropTypes.object,
        selectedSiteId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        // User
        user: MapPropTypes.UserProps,
        editCart: PropTypes.bool,
        showCart: PropTypes.bool,
        showOfferSelect: PropTypes.bool,
        cart: PropTypes.arrayOf(
            PropTypes.shape({
                item: MapPropTypes.CartItemProps,
                product: MapPropTypes.PricingProps,
            })
        ).isRequired,
        selectedProductIndex: PropTypes.number,
        showAlert: PropTypes.bool,
        helpSubjectIndex: PropTypes.number,

    };
    constructor(props) {
        super(props);
        this.state = {
            cartErrorMessage: '', editCart: false,
        };
        this._validateCartItemsAndProceedToShoppingCart = this._validateCartItemsAndProceedToShoppingCart.bind(this);
    }

    static mapState = (state) =>
        mapSelectors(state, {
            offer: selectors.offer.getSelectedOffer,
            selectedOfferIndex: selectors.offer.getSelectedOfferIndex,
            offers: selectors.offer.getOffers,
            showOfferSelect: selectors.offer.showOfferSelect,
            showCart: selectors.cart.showCart,
            editCartItems: selectors.cart.editCart,
            cart: selectors.cart.getCartContents,
            offersRetrieved: selectors.offer.getOffersRetrieved,
            offerIsUsable: selectors.offer.getOfferIsUsable,
            readyForCheckout: selectors.cart.readyForCheckout,
            readyForaddToCart: selectors.cart.readyForaddToCart,
            selectedProductIndex: selectors.offer.getSelectedProductIndex,
            // site
            sites: selectors.sites.getSites,
            selectedSite: selectors.sites.getSelectedSite,
            selectedSiteId: selectors.sites.getSelectedSiteId,
            showAlert: selectors.sites.showAlert,
            user: selectors.user.getMyself,
        });

    static mapDispatch = (dispatch) => ({
        addProductToCart: (productIndex) =>
            dispatch(CartActions.addProductToCart(productIndex)),
        openModal: (modalName) => dispatch(UiActions.openModal(modalName)),
        openHelpModal: () => {
            dispatch(HelpActions.showContactTab());
            dispatch(
                HelpActions.updateContactSubjectIndex(
                    HelpActions.contactSubjects.indexOf('General Inquiry')
                )
            );
            dispatch(UiActions.openHelpModal());
        },
        selectOffer: (offerIndex) =>
            dispatch(OfferActions.selectOffer(offerIndex)),
        setItems: () =>
            dispatch(CartActions.setItems()),
        selectProduct: (productIndex) =>
            dispatch(OfferActions.selectProduct(productIndex)),
        selectSite: (id) => dispatch(SiteActions.selectSite(id)),
        // fetchAllSites: () => dispatch(SiteActions.fetchSites()),
        downloadConfigurationProductList: (id) =>
            dispatch(OrderActions.downloadConfigurationProductList(id)),
        saveShoppingCart: (userId) =>
            dispatch(CartActions.saveShoppingCart(userId)),
    });

    _handleSiteSelected(id) {
        this.props.selectSite(id);
    }

    _handleOfferChange(option) {
        this.props.selectOffer(option.value);
        this.props.setItems();
        this.props.selectProduct(-1);
        this._renderOrderForm;
        this.setState({ editCart: false, cartErrorMessage: '' });
    }

    _checkProductConfig() {
        return this.props.offer.enterprise_deal || this._checkAllowedCompany(
            this.props.offer.account.soldTo, PRODUCT);
    }

    _checkAllowedCompany(soldto, type) {
        let allowed = false;
        switch (type) {
            case SERVER:
                allowed = process.env.SERVER_ALLOWED_COMPANIES.includes(soldto) ? true : false;
                break;
            case PRODUCT:
                allowed = process.env.PRODUCT_ALLOWED_COMPANIES.includes(soldto) ? true : false;
                break;
        }
        return allowed;
    }

    _checkServerConfig() {
        return this._checkAllowedCompany(this.props.offer.account.soldTo, SERVER);
    }

    _closeEditCart() {
        // set edit cart items back to false and then reset state.
        this.props.saveShoppingCart(this.props.user.id);
        this.setState({ editCart: false, });
    }

    handleEditCartChange = (value) => {
        this.setState({ editCart: value });
    };

    _handleProductListDownload(id) {
        this.props.downloadConfigurationProductList(id);
    }

    _validateCartItemsAndCheckout() {
        let isValidCart = true;
        let cartErrorMessage = '';
        this.setState({
            cartErrorMessage,
        });
        // commenting the check for number of seats for tier pricing and allowing to place the order 
        // this.props.cart.forEach((item) => {
        //     if (!item.isTieredDiscountApplied && item.pricing.tieredDiscount) {
        //         // check for number of seats
        //         if (item.seats < 11) {
        //             isValidCart = false;
        //             cartErrorMessage =
        //                 item.pricing.product.name +
        //                 ` is using the lower price tier. Therefore you need to keep a minimum of 11 active licenses. Currently there ${item.seats === 1 ? 'is' : 'are'
        //                 } ${item.seats}  active license(s) in this time window`;
        //         }
        //     }
        // });
        if (isValidCart) {
            this.props.openModal('checkout');
        }
        this.setState({
            cartErrorMessage,
        });
    }

    _validateCartItemsAndProceedToShoppingCart(itemIndex = undefined, saveForLater = false) {
        let isValidCart = true;
        let cartErrorMessage = '';
        itemIndex
        this.setState({
            cartErrorMessage,
        });

        this.props.cart.forEach((item, index) => {
            if (itemIndex !== undefined && index != itemIndex) {
                return;
            }
            item.addedToCart = true;
            item.saveForLater = saveForLater;
            // commenting the  check for number of seats for tier pricing and allowing to place the order 
            // if (!item.isTieredDiscountApplied && item.pricing.tieredDiscount) {
            //     // check for number of seats
            //     if (item.seats < 11) {
            //         isValidCart = false;
            //         cartErrorMessage =
            //             item.pricing.product.name +
            //             ` is using the lower price tier. Therefore you need to keep a minimum of 11 active licenses. Currently there ${
            //                 item.seats === 1 ? 'is' : 'are'
            //             } ${item.seats}  active license(s) in this time window`;
            //     }
            // }
        });
        if (isValidCart) {
            this.props.saveShoppingCart(this.props.user.id);
            // Disabling opening of shopping cart pop up on save and keeping it for future use in case business changes their mind.
            // if(itemIndex === undefined){
            //     this.props.openModal('shoppingcart');
            // }
        }
        this.setState({
            cartErrorMessage,
        });
    }

    _renderOfferSelect() {
        if (!this.props.showOfferSelect) {
            return <span />;
        }

        function itemRenderer({ offer }) {
            return (
                <div>
                    <strong>
                        {offer.mentorId} - {offer.account.name}
                    </strong>{' '}
                    <small className="p-l text-mute">
                        <Icon name="icon-calendar" />{' '}
                        {utils.formatShortDate(offer.validFrom)} -{' '}
                        {utils.formatShortDate(offer.validTo)}
                    </small>
                </div>
            );
        }

        return (
            <div className="p-a bg-info-light border-all m-b br-a-sm">
                <div className="offer-select">
                    <Select
                        value={this.props.selectedOfferIndex}
                        multi={false}
                        clearable={false}
                        searchable={this.props.offers.length > 3}
                        options={this.props.offers.map((offer, index) => ({
                            value: index,
                            label: `${strings.dealId} ${offer.mentorId}`,
                            offer,
                        }))}
                        onChange={(option) => this._handleOfferChange(option)}
                        valueRenderer={itemRenderer}
                        optionRenderer={itemRenderer}
                    />
                </div>
            </div>
        );
    }

    _renderCart() {
        if (!this.props.showCart && !this.state.editCart) {
            return <span />;
        }

        return (
            <div className="card m-b-0 cart">
                <Cart editCart={this.state.editCart}
                    SaveCartItem={this._validateCartItemsAndProceedToShoppingCart} /> {/* redux connected */}
            </div>
        );
    }

    _renderOrderForm() {
        
        return (
            <div className="order-form">
                {this.state.cartErrorMessage ? (
                    <div className="row text-center text-danger ">
                        {this.state.cartErrorMessage}
                    </div>
                ) : null}
                <div className="row">
                    <div className="col-md-6">{this._renderOfferSelect()}</div>
                </div>
                <div className="card m-a-0">
                    <div className="row row-flex middle-xs row-flush row-bordered">
                        <div className="col-md-12 flex-align-top">
                            <div className="p-a-md">
                                {!this.state.editCart ? (<Selector
                                    offer={this.props.offer}
                                    addProductToCart={
                                        this.props.addProductToCart
                                    }
                                    selectedProductIndex={
                                        this.props.selectedProductIndex
                                    }
                                    selectProduct={this.props.selectProduct}
                                />) : (<div>
                                    <h1 className='card-header'>Your Cart</h1>
                                </div>)}
                                {this._renderCart()}
                            </div>
                        </div>
                        <div className="col-md-12 text-center">
                            <Balance editCart={this.state.editCart} /> {/* redux connected */}
                        </div>
                    </div>
                </div>
                <div className="m-t-md text-right footer">
                    <div className="row">
                        <div className="col-md-6">
                            <button
                                id="pricingBtn"
                                onClick={() => this.props.openModal('pricing')}
                                className="btn btn-info pull-left pricing-btn"
                            >
                                <Icon name="icon-table" /> {strings.pricing}
                            </button>
                        </div>
                        {!this.state.editCart ?
                            (<div>
                                <div className="col-md-3">
                                    <button
                                        id="saveForlater"
                                        className="btn btn-xl btn-primary btn-block order-button"
                                        disabled={!this.props.readyForaddToCart}
                                        onClick={() => this._validateCartItemsAndProceedToShoppingCart(undefined, true)}
                                    >
                                        {strings.saveForLater}{' '}
                                        <Icon name="icon-arrow-right4" />
                                    </button>
                                </div>
                                <div className="col-md-3">
                                    <button
                                        id="addToCart"
                                        className="btn btn-xl btn-primary btn-block order-button"
                                        disabled={!this.props.readyForaddToCart}
                                        onClick={() => this._validateCartItemsAndProceedToShoppingCart()}
                                    >
                                        {strings.addToCart}{' '}
                                        <Icon name="icon-arrow-right4" />
                                    </button>
                                </div>
                            </div>) : (
                                <div>
                                    <div className="col-md-3">
                                        <button
                                            className="btn btn-xl btn-primary btn-block order-button"
                                            disabled={!this.props.readyForCheckout}
                                            onClick={() => this._closeEditCart()}
                                        >
                                            {strings.saveAndContinueShopping}{' '}
                                            <Icon name="icon-arrow-right4" />
                                        </button>
                                    </div>
                                    <div className="col-md-3">
                                        <button
                                            className="btn btn-xl btn-primary btn-block order-button"
                                            disabled={!this.props.readyForCheckout}
                                            // onClick={() => this.props.openModal('checkout')}
                                            onClick={() =>
                                                this._validateCartItemsAndCheckout()
                                            }
                                        >
                                            {strings.checkout}{' '}
                                            <Icon name="icon-arrow-right4" />
                                        </button>
                                    </div>
                                </div>)}
                    </div>
                </div>
                <p>&nbsp;</p>
                {this._checkProductConfig() ? (
                    <div>
                        <div className="card m-a-0">
                            <div className="row row-flex middle-xs row-flush row-bordered">
                                <div className="col-md-12 flex-align-bottom">
                                    <div className="p-a-md">
                                        <div className="card raised-sm border-none product-selector">
                                            <div className="card-header card-header-success text-inverse">
                                                <b>
                                                    Configure products with a
                                                    template
                                                </b>
                                            </div>
                                            <div className="card-block">
                                                <Grid>
                                                    <Row className="show-grid align-items-center">
                                                        <UploadConfiguration
                                                            downloadConfigurationProductList={(
                                                                id
                                                            ) =>
                                                                this._handleProductListDownload(
                                                                    id
                                                                )
                                                            }
                                                        />
                                                    </Row>
                                                </Grid>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>&nbsp;</p>
                    </div>
                ) : (
                    <div></div>
                )}
                {this._checkServerConfig() ? (
                    <div>
                        <div className="card m-a-0">
                            <div className="row row-flex middle-xs row-flush row-bordered">
                                <div className="col-md-12 flex-align-bottom">
                                    <div className="p-a-md">
                                        <AddHostServer
                                            selectedSiteId={
                                                this.props.selectedSiteId
                                            }
                                            selectedSite={
                                                this.props.selectedSite
                                            }
                                            selectSite={(id) =>
                                                this._handleSiteSelected(id)
                                            }
                                            sites={this.props.offer.sites}
                                            showAlert={this.props.showAlert}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
                <PricingModal /> {/* redux connected */}
                <ShoppingCartModal onEditCartChange={this.handleEditCartChange} /> {/* redux connected */}
                <CheckoutModal onEditCartChange={this.handleEditCartChange} /> {/* redux connected */}
            </div>
        );
    }

    render() {
        if (!this.props.offerIsUsable) {
            if (this.props.offersRetrieved) {
                return (
                    <div>
                        <h1>{strings.noOffersAvailable}</h1>
                        <p>
                            <a
                                className="cursor-pointer"
                                onClick={() =>
                                    this.props.openHelpModal(this.props.helpSubjectIndex)}
                            >
                                {strings.contactForHelp}
                            </a>
                        </p>
                    </div>
                );
            }
            return <div />;
        }
        return this._renderOrderForm();
    }
}

export default attach(OrderForm);



// WEBPACK FOOTER //
// ./app/components/OrderForm/index.jsx